export default require("./node_modules/vform3-builds/dist/designer.umd.js");